package com.yendo.mx.ui.components

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Star
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.yendo.mx.models.Reputacion
import com.yendo.mx.utils.formatDecimal

/**
 * Componente reutilizable para mostrar la reputación de un restaurante.
 * 
 * Reglas:
 * - Menos de 5 reseñas: Muestra badge "✨ Nuevo"
 * - 5 o más reseñas: Muestra "⭐ Promedio (Total)"
 */
@Composable
fun RestauranteRatingBadge(
    reputacion: Reputacion?,
    modifier: Modifier = Modifier,
    forceWhiteText: Boolean = false
) {
    val totalResenas = reputacion?.totalResenas ?: 0
    val calificacion = reputacion?.calificacionPromedio ?: 0.0
    val colorTexto = if (forceWhiteText) Color.White else MaterialTheme.colorScheme.onSurface

    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (totalResenas < 5) {
            // ✨ CONDICIÓN: NEGOCIO NUEVO
            Surface(
                color = Color(0xFFE8F5E9), // Verde muy claro
                shape = RoundedCornerShape(6.dp)
            ) {
                Text(
                    text = "Nuevo",
                    color = Color(0xFF2E7D32), // Verde bosque fuerte
                    fontSize = 11.sp,
                    fontWeight = FontWeight.ExtraBold,
                    modifier = Modifier.padding(horizontal = 8.dp, vertical = 2.dp)
                )
            }
        } else {
            // ⭐ CONDICIÓN: ESTABLECIDO
            Icon(
                imageVector = Icons.Default.Star,
                contentDescription = null,
                tint = Color(0xFFFFB300), // Amarillo ámbar
                modifier = Modifier.size(16.dp)
            )
            
            Spacer(Modifier.width(4.dp))
            
            Text(
                text = formatDecimal(calificacion, 1),
                fontSize = 13.sp,
                fontWeight = FontWeight.Bold,
                color = colorTexto
            )
            
            Spacer(Modifier.width(4.dp))
            
            Text(
                text = "($totalResenas)",
                fontSize = 12.sp,
                color = if (forceWhiteText) Color.White.copy(alpha = 0.7f) else Color.Gray
            )
        }
    }
}
